import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

const DragAndDropIcon = ({ color }: { color?: string; [x: string]: unknown }) => {
  const { token } = useToken();
  const currentColor = color ?? token.colorBgContainer;
  return (
    <svg width="21px" height="21px" viewBox="0 0 21 21" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter x="-26.7%" y="-26.7%" width="153.3%" height="153.3%" filterUnits="objectBoundingBox" id="filter-1">
          <feOffset dx="1" dy="1" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
          <feGaussianBlur stdDeviation="0.5" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
            type="matrix"
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
          ></feColorMatrix>
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
            <feMergeNode in="SourceGraphic"></feMergeNode>
          </feMerge>
        </filter>
      </defs>
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Compressors-Rotation-off" transform="translate(-475.000000, -467.000000)" fillRule="nonzero">
          <g id="Group-3" transform="translate(85.000000, 254.000000)">
            <g id="Group" transform="translate(383.000000, 162.000000)">
              <g id="Group-17" transform="translate(0.000000, 46.000000)">
                <g id="Group-11" transform="translate(10.000000, 8.000000)">
                  <g id="menu" filter="url(#filter-1)" fill={currentColor}>
                    <path
                      d="M1.875,0 C2.91053391,0 3.75,0.839466094 3.75,1.875 C3.75,2.91053391 2.91053391,3.75 1.875,3.75 C0.839466094,3.75 0,2.91053391 0,1.875 C0,0.839466094 0.839466094,0 1.875,0 L1.875,0 Z"
                      id="Path"
                    ></path>
                    <path
                      d="M1.875,5.625 C2.91053391,5.625 3.75,6.46446609 3.75,7.5 C3.75,8.53553391 2.91053391,9.375 1.875,9.375 C0.839466094,9.375 0,8.53553391 0,7.5 C0,6.46446609 0.839466094,5.625 1.875,5.625 Z"
                      id="Path"
                    ></path>
                    <path
                      d="M1.875,11.25 C2.91053391,11.25 3.75,12.0894661 3.75,13.125 C3.75,14.1605339 2.91053391,15 1.875,15 C0.839466094,15 0,14.1605339 0,13.125 C0,12.0894661 0.839466094,11.25 1.875,11.25 Z"
                      id="Path"
                    ></path>
                    <path
                      d="M13.125,0 C14.1605339,0 15,0.839466094 15,1.875 C15,2.91053391 14.1605339,3.75 13.125,3.75 C12.0894661,3.75 11.25,2.91053391 11.25,1.875 C11.25,0.839466094 12.0894661,0 13.125,0 L13.125,0 Z"
                      id="Path"
                    ></path>
                    <path
                      d="M7.5,5.625 C8.53553391,5.625 9.375,6.46446609 9.375,7.5 C9.375,8.53553391 8.53553391,9.375 7.5,9.375 C6.46446609,9.375 5.625,8.53553391 5.625,7.5 C5.625,6.46446609 6.46446609,5.625 7.5,5.625 Z"
                      id="Path"
                    ></path>
                    <path
                      d="M13.125,11.25 C14.1605339,11.25 15,12.0894661 15,13.125 C15,14.1605339 14.1605339,15 13.125,15 C12.0894661,15 11.25,14.1605339 11.25,13.125 C11.25,12.0894661 12.0894661,11.25 13.125,11.25 Z"
                      id="Path"
                    ></path>
                    <path
                      d="M7.5,0 C8.53553391,0 9.375,0.839466094 9.375,1.875 C9.375,2.91053391 8.53553391,3.75 7.5,3.75 C6.46446609,3.75 5.625,2.91053391 5.625,1.875 C5.625,0.839466094 6.46446609,0 7.5,0 L7.5,0 Z"
                      id="Path"
                    ></path>
                    <path
                      d="M13.125,5.625 C14.1605339,5.625 15,6.46446609 15,7.5 C15,8.53553391 14.1605339,9.375 13.125,9.375 C12.0894661,9.375 11.25,8.53553391 11.25,7.5 C11.25,6.46446609 12.0894661,5.625 13.125,5.625 Z"
                      id="Path"
                    ></path>
                    <path
                      d="M7.5,11.25 C8.53553391,11.25 9.375,12.0894661 9.375,13.125 C9.375,14.1605339 8.53553391,15 7.5,15 C6.46446609,15 5.625,14.1605339 5.625,13.125 C5.625,12.0894661 6.46446609,11.25 7.5,11.25 Z"
                      id="Path"
                    ></path>
                  </g>
                  <g id="menu-copy-3" transform="translate(1.000000, 1.000000)" stroke="#979797" strokeWidth="0.2">
                    <path
                      d="M1.875,0 C2.91053391,0 3.75,0.839466094 3.75,1.875 C3.75,2.91053391 2.91053391,3.75 1.875,3.75 C0.839466094,3.75 0,2.91053391 0,1.875 C0,0.839466094 0.839466094,0 1.875,0 L1.875,0 Z"
                      id="Path"
                    ></path>
                    <path
                      d="M1.875,5.625 C2.91053391,5.625 3.75,6.46446609 3.75,7.5 C3.75,8.53553391 2.91053391,9.375 1.875,9.375 C0.839466094,9.375 0,8.53553391 0,7.5 C0,6.46446609 0.839466094,5.625 1.875,5.625 Z"
                      id="Path"
                    ></path>
                    <path
                      d="M1.875,11.25 C2.91053391,11.25 3.75,12.0894661 3.75,13.125 C3.75,14.1605339 2.91053391,15 1.875,15 C0.839466094,15 0,14.1605339 0,13.125 C0,12.0894661 0.839466094,11.25 1.875,11.25 Z"
                      id="Path"
                    ></path>
                    <path
                      d="M13.125,0 C14.1605339,0 15,0.839466094 15,1.875 C15,2.91053391 14.1605339,3.75 13.125,3.75 C12.0894661,3.75 11.25,2.91053391 11.25,1.875 C11.25,0.839466094 12.0894661,0 13.125,0 L13.125,0 Z"
                      id="Path"
                    ></path>
                    <path
                      d="M7.5,5.625 C8.53553391,5.625 9.375,6.46446609 9.375,7.5 C9.375,8.53553391 8.53553391,9.375 7.5,9.375 C6.46446609,9.375 5.625,8.53553391 5.625,7.5 C5.625,6.46446609 6.46446609,5.625 7.5,5.625 Z"
                      id="Path"
                    ></path>
                    <path
                      d="M13.125,11.25 C14.1605339,11.25 15,12.0894661 15,13.125 C15,14.1605339 14.1605339,15 13.125,15 C12.0894661,15 11.25,14.1605339 11.25,13.125 C11.25,12.0894661 12.0894661,11.25 13.125,11.25 Z"
                      id="Path"
                    ></path>
                    <path
                      d="M7.5,0 C8.53553391,0 9.375,0.839466094 9.375,1.875 C9.375,2.91053391 8.53553391,3.75 7.5,3.75 C6.46446609,3.75 5.625,2.91053391 5.625,1.875 C5.625,0.839466094 6.46446609,0 7.5,0 L7.5,0 Z"
                      id="Path"
                    ></path>
                    <path
                      d="M13.125,5.625 C14.1605339,5.625 15,6.46446609 15,7.5 C15,8.53553391 14.1605339,9.375 13.125,9.375 C12.0894661,9.375 11.25,8.53553391 11.25,7.5 C11.25,6.46446609 12.0894661,5.625 13.125,5.625 Z"
                      id="Path"
                    ></path>
                    <path
                      d="M7.5,11.25 C8.53553391,11.25 9.375,12.0894661 9.375,13.125 C9.375,14.1605339 8.53553391,15 7.5,15 C6.46446609,15 5.625,14.1605339 5.625,13.125 C5.625,12.0894661 6.46446609,11.25 7.5,11.25 Z"
                      id="Path"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default DragAndDropIcon;
